export const PAID = "Paid",
	PAST_DUE = "Past Due",
	DUE_NOW = "Due Now",
	DUE_SOON = "Due Soon";

export const LATE_DAY_PERIOD = 30;
